import React from 'react';

const CHUNK_ERROR_KEY = 'chunkErrorReloaded';

const isChunkLoadError = error => {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const msg = error.message || String(error);
  return (
    msg.includes('Loading CSS chunk') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  );
};

export default class ChunkErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    if (isChunkLoadError(error)) {
      if (!sessionStorage.getItem(CHUNK_ERROR_KEY)) {
        sessionStorage.setItem(CHUNK_ERROR_KEY, '1');
        window.location.reload();
      } else {
        sessionStorage.removeItem(CHUNK_ERROR_KEY);
      }
      return { hasError: true };
    }
    return { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    if (isChunkLoadError(error)) {
      console.error('Chunk load error caught by boundary:', error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
